import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const Header = () => {
  const [activeTab, setActiveTab] = useState("customer");
  const [isHiddenTable, setIsHiddenTable] = useState(true);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();
  const toggleHiddenTable = () => setIsHiddenTable(!isHiddenTable);

  // ✅ OWNER LOGIN HANDLER
  const handleOwnerLogin = async () => {
    toggleHiddenTable();
      setIsHiddenTable(false);
    if (!email || !password) {
      alert("Please enter email & password");
      return;
    }

    try {
      const res = await fetch(
        "https://rbhardwaj.com/ownerlogin.php"
      );
      const data = await res.json();

      const owner = data.find(
        (u) => u.email === email && u.password === password
      );

      if (!owner) {
        alert("Invalid Owner Credentials");
        return;
      }

      // ✅ save auth
      localStorage.setItem("isAdminLoggedIn", "true");

      navigate("/admin");
    } catch (err) {
      console.error(err);
      alert("Login failed");
    }
  };

  return (
    <>
      <header>
        <nav>
          <h2>Personal Loan</h2>
          <div className="navlink_div">
            <button onClick={toggleHiddenTable}>Login</button>
          </div>
        </nav>
      </header>

      <div
        style={{
          ...styles.container,
          display: isHiddenTable ? "none" : "block",
        }}
      >
        <p
          onClick={toggleHiddenTable}
          style={{
            position: "absolute",
            top: "10px",
            right: "20px",
            fontSize: "20px",
            cursor: "pointer",
          }}
        >
          ✖
        </p>

        <h2 style={{ textAlign: "center" }}>Login</h2>

        {/* Tabs */}
        <div className="tab-header">
          <button
            className={`tab-btn ${activeTab === "customer" ? "active" : ""}`}
            onClick={() => setActiveTab("customer")}
          >
            Customer Login
          </button>

          <button
            className={`tab-btn ${activeTab === "owner" ? "active" : ""}`}
            onClick={() => setActiveTab("owner")}
          >
            Owner Login
          </button>
        </div>

        <br />

        {/* CUSTOMER LOGIN */}
        {activeTab === "customer" && (
          <div className="customerlogin">
            <div className="formlabeldiv">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <label>Customer Email</label>
            </div>

            <div className="formlabeldiv">
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <label>Password</label>
            </div>

            <Link
              to="/mudraapproval"
              state={{ email, password }}
              onClick={toggleHiddenTable}
            >
              <button type="submit" style={styles.button}>Login</button>
            </Link>
          </div>
        )}

        {/* OWNER LOGIN */}
        {activeTab === "owner" && (
          <div className="ownerlogin">
            <div className="formlabeldiv">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <label>Owner Email</label>
            </div>

            <div className="formlabeldiv">
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <label>Password</label>
            </div>

            <button type="submit"
              onClick={handleOwnerLogin}
              style={styles.button}
              
            >
              Login
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default Header;


const styles = {
  container: {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: "500",
    maxWidth: "400px",
    padding: "30px",
    background: "#fff",
    borderRadius: "10px",
    width: "100%",
    boxShadow: "1px 1px 100px rgba(0, 0, 0, 0.27)",
  },

  button: {
    width: "100%",
    padding: "10px",
    marginTop: "10px",
    cursor: "pointer",
  },
};
